export const defaultModuleObject = {
    "pvmodid": "1267ce7c-ef19-40c9-9128-867a97c5c9b1",
    "code": "Bi-66-595",
    "manufacturer": "Waaree",
    "technology": "Mono-c-Si",
    "bifacial": 0.7,
    "stc": 595,
    "ptc": null,
    "length": 2.19,
    "width": 1.302,
    "a_c": 2.85138,
    "thickness": 35,
    "n_s": 120,
    "i_sc_ref": 17.9,
    "v_oc_ref": 42.05,
    "i_mp_ref": 17.29,
    "v_mp_ref": 34.44,
    "alpha_sc": 0.040000003,
    "beta_oc": -0.25000003,
    "gamma_r": -0.35,
    "t_noct": 43,
    "a_ref": null,
    "i_l_ref": null,
    "i_o_ref": null,
    "r_s": null,
    "r_sh_ref": null,
    "adjust": null,
    "bipv": "No",
    "version": "Bi-66-595",
    "date": "2026-01-30T07:05:33.010782Z",
    "priority": 3,
    "activestatus": true,
    "createdat": "2026-01-30T07:05:33.010782Z",
    "updatedat": "2026-01-30T07:05:33.010782Z",
    "type": "PV Module",
    "created_by_userid": null,
    "pan_file": null,
    "is_approved": false,
    "is_global": false,
    "product_warranty": 12,
    "performance_warranty": 30,
    "annual_degradation_override": 0.61,
    "modulecost": 18000
}